import { Grid, Select, Table } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { CompassOutlined, EnvironmentOutlined } from '@ant-design/icons';
// import Map from '../../../home/components/Map';
import useGroup from '../../../../zustand/useGroup';
import useAppliedReportFilter from '../../../../hooks/useAppliedReportFilter';
import useReportLog from '../../../../hooks/useReportLog';
import { latToDMS, longToDMS, toKnot } from '../helperFunction';
import useReportSummaryData from '../../../../hooks/useReportSummaryData';
import MapCustom from '../../../home/components/MapCustom';
import useMapSetting from '../../../../zustand/useMap';
import {
  EFormatCurrentDate,
  formatCurrentDate,
} from '../../../../helpers/formatCurrentDate';
import { speedUnitOptions, cruiseUnitOptions } from '../../../../helpers/unit';
import { useVesselTrackingGps } from './useVesselTrackingGps';

const defaultDataTable = [
  {
    key: '1',
    header: 'Start',
    position: '',
    time: '',
    speed: '',
  },
  {
    key: '2',
    header: 'End',
    position: '',
    time: '',
    speed: '',
  },
  {
    key: '3',
    header: 'Average Speed',
    position: '',
    time: '',
    speed: '',
  },
  {
    key: '4',
    header: 'Total Cruise',
    position: '',
    time: '',
    speed: '',
  },
];

const VesselTracking = () => {
  const screens = Grid.useBreakpoint();
  const isMobile = screens.md === false;
  const { dataSource } = useGroup();
  const { filter, asset, timezone } = useAppliedReportFilter();
  const {
    loadingLog: loading,
    logs,
    setSpeedUnit,
    speedUnit,
    cruiseUnit,
    setCruiseUnit,
  } = useReportLog();
  const { gpsLogs, loading: loadingTrackingGps } = useVesselTrackingGps();
  const [loadingLastDataLog, setLoadingLastDataLog] = useState<boolean>(false);
  const [lastDataLog, setLastDataLog] = useState<any>({});

  const {
    showVesselOnline,
    showVesselOffline,
    showVesselWaiting,
    showVesselLabel,
    showDotTrail,
    trailWidth,
    trailOpacity,
    trailLength,
    mapType,
  } = useMapSetting();

  const [showSections, setShowSections] = useState({
    section1: true,
    section2: true,
  });

  const handleToggleSection = (section: keyof typeof showSections) => {
    setShowSections((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  const columnsVesselTracking: any = [
    {
      title: ' ',
      dataIndex: 'header',
      key: 'header',
    },
    {
      title: 'Position',
      dataIndex: 'position',
      key: 'position',
      onCell: (_: any, index: number) => ({
        colSpan: index === 3 || index === 2 || index === 4 ? 3 : 1,
      }),
      render: (value: any, records: any, index: number) => {
        if (index === 2) {
          return (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '4px 0',
              }}
            >
              <div>{value}</div>
              <Select
                size='small'
                value={speedUnit}
                style={{ width: 80 }}
                onChange={(e) => setSpeedUnit(e)}
                options={speedUnitOptions}
              />
            </div>
          );
        } else if (index === 3) {
          // Total Cruise row with dropdown
          return (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '4px 0',
              }}
            >
              <div>{value}</div>
              <Select
                size='small'
                value={cruiseUnit}
                style={{ width: 80 }}
                onChange={(e) => setCruiseUnit(e)}
                options={cruiseUnitOptions}
              />
            </div>
          );
        } else {
          return value;
        }
      },
    },
    {
      title: 'Time',
      dataIndex: 'time',
      key: 'time',
      onCell: (_: any, index: number) => ({
        colSpan: index === 3 || index === 2 || index === 4 ? 0 : 1,
      }),
    },
    {
      title: 'Speed',
      dataIndex: 'speed',
      key: 'speed',
      onCell: (_: any, index: number) => ({
        colSpan: index === 3 || index === 2 || index === 4 ? 0 : 1,
      }),
      render: (value: any, records: any, index: number) => {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: '4px 0',
            }}
          >
            <div>{speedUnit === 'KNOT' ? toKnot(value).toFixed(2) : value}</div>
            <Select
              size='small'
              value={speedUnit}
              style={{ width: 80 }}
              onChange={(e) => setSpeedUnit(e)}
              options={speedUnitOptions}
            />
          </div>
        );
      },
    },
  ];

  // const data = useMemo(() => {
  //   if (logs && Object.keys(logs).length) {
  //     const containerTimestamp = generateTimestampData({
  //       startTime: filter.startAt,
  //       endTime: filter.endAt,
  //       interval: filter.interval,
  //     });

  //     const results = containerTimestamp.map((timestamp) => {
  //       let fm;
  //       let rpm;
  //       let ae;
  //       let gps;
  //       if (logs.flowmeter) {
  //         const foundKey = Object.keys(logs.flowmeter).find(
  //           (key) => Number(key) === timestamp
  //         );
  //         if (foundKey) {
  //           fm = logs.flowmeter[foundKey];
  //         }
  //       }
  //       if (logs.rpm) {
  //         const foundKey = Object.keys(logs.rpm).find(
  //           (key) => Number(key) === timestamp
  //         );
  //         if (foundKey) {
  //           rpm = logs.rpm[foundKey];
  //         }
  //       }
  //       if (logs.ae) {
  //         const foundKey = Object.keys(logs.ae).find(
  //           (key) => Number(key) === timestamp
  //         );
  //         if (foundKey) {
  //           ae = logs.ae[foundKey];
  //         }
  //       }
  //       if (logs.gps) {
  //         const foundKey = Object.keys(logs.gps).find(
  //           (key) => Number(key) === timestamp
  //         );
  //         if (foundKey) {
  //           gps = logs.gps[foundKey];
  //         }
  //       }

  //       return {
  //         timestamp,
  //         dateTime: dayjs(timestamp * 1000).format('DD MMM YYYY HH:mm'),
  //         gps_coordinate:
  //           gps?.latitude && gps?.longitude
  //             ? `${latToDMS(gps?.latitude)}, ${longToDMS(gps?.longitude)}`
  //             : '-',
  //         gps_latitude: gps?.latitude,
  //         gps_longitude: gps?.longitude,
  //         gps_altitude: gps?.altitude,
  //         gps_heading: convertData(gps?.heading),
  //         gps_speed: convertData(gps?.speed),
  //         gps_distance: convertData(gps?.distance),
  //         port_Rpm: convertData(rpm?.port?.rpm),
  //         port_RunningTime: toHHMMSS(rpm?.port?.runningTime),
  //         port_FuelCons: convertData(fm?.deviceCalculation?.portIn?.fuelCons),
  //         port_VolumeTotal: convertData(
  //           fm?.deviceCalculation?.portIn?.volumeFuelCons
  //         ),
  //         port_InFlow: convertData(fm?.portIn?.volumeFlowrate),
  //         port_Temperature: convertData(fm?.portIn?.temperature),
  //         port_InDensity: convertData(fm?.portIn?.density),
  //         starboard_Rpm: convertData(rpm?.starboard?.rpm),
  //         starboard_RunningTime: toHHMMSS(rpm?.starboard?.runningTime),
  //         starboard_FuelCons: convertData(
  //           fm?.deviceCalculation?.starboardIn?.fuelCons
  //         ),
  //         starboard_VolumeTotal: convertData(
  //           fm?.deviceCalculation?.starboardIn?.volumeFuelCons
  //         ),
  //         starboard_InFlow: convertData(fm?.starboardIn?.volumeFlowrate),
  //         starboard_Temperature: convertData(fm?.starboardIn?.temperature),
  //         starboard_InDensity: convertData(fm?.starboardIn?.density),
  //         ae1_RunningTime: toHHMMSS(ae?.ae1?.runningTime),
  //         ae1_FuelConsumption: convertData(ae?.ae1?.fuelConsumption),
  //         ae2_RunningTime: toHHMMSS(ae?.ae2?.runningTime),
  //         ae2_FuelConsumption: convertData(ae?.ae2?.fuelConsumption),
  //         ae3_RunningTime: toHHMMSS(ae?.ae3?.runningTime),
  //         ae3_FuelConsumption: convertData(ae?.ae3?.fuelConsumption),
  //       };
  //     });

  //     return results;
  //   }
  // }, [logs]);

  // const getReportLogRPM = async () => {
  //   try {
  //     let newFilter = { ...filter };

  //     newFilter = {
  //       ...newFilter,
  //       deviceType: 'rpm',
  //     };

  //     const res = await httpRequest.get(
  //       `/report-log/${generateQueryString(newFilter)}`
  //     );

  //     const keys = Object.keys(res.data.payload.rpm);
  //     const lastKey = keys[keys.length - 1];
  //     const lastDataRPM = res.data.payload.rpm[lastKey];

  //     // console.log(lastDataRPM);

  //     setLastDataLogRPM(lastDataRPM);
  //   } catch (error) {
  //     console.error(getErrorMessage(error));
  //   }
  // };

  // useEffect(() => {
  //   if (data) {
  //     const dataLength = data.length;
  //     let sum = 0;

  //     data.forEach((value) => {
  //       sum += Number(value.gps_speed);
  //     });

  //     const avgSpeed = sum / data.length;

  //     setDataSourceVesselTracking((prev) =>
  //       prev.map((item) =>
  //         item.key === '1'
  //           ? {
  //               ...item,
  //               position: data[0]?.gps_coordinate,
  //               time: data[0]?.dateTime,
  //               speed: data[0]?.gps_speed,
  //             }
  //           : item.key === '2'
  //           ? {
  //               ...item,
  //               position: data[dataLength - 1]?.gps_coordinate,
  //               time: data[dataLength - 1]?.dateTime,
  //               speed: data[dataLength - 1]?.gps_speed,
  //             }
  //           : item.key === '3'
  //           ? {
  //               ...item,
  //               position: avgSpeed ? avgSpeed.toFixed(2) : '-',
  //             }
  //           : {
  //               ...item,
  //               position: '-',
  //             }
  //       )
  //     );

  //     getReportLogRPM();
  //   }
  // }, [data]);

  // const getLastDataLogDevice = async (
  //   customParams: {
  //     deviceType: string;
  //     interval: string;
  //     assetIds: string;
  //     trailLength: number;
  //   },
  //   showDotTrail?: boolean
  // ) => {
  //   try {
  //     setLoadingLastDataLog(true);

  //     const newFilter = {
  //       deviceType: showDotTrail ? 'gps' : customParams.deviceType,
  //       interval: customParams.interval,
  //       lastDataLimit:
  //         showDotTrail && customParams.trailLength
  //           ? customParams.trailLength * 60
  //           : 1,
  //       assetIds: customParams.assetIds,
  //     };

  //     const results = await httpRequest.get<
  //       BaseResponseProps<LastDataLogProps>
  //     >(`/report-log/last-data/by-assets${generateQueryString(newFilter)}`);

  //     if (showDotTrail) {
  //       const newData = results.data.payload;
  //       const newLastDataLog = { ...lastDataLog };

  //       for (const device in newData) {
  //         if (
  //           newData.hasOwnProperty(device) &&
  //           newLastDataLog.hasOwnProperty(device)
  //         ) {
  //           const newGpsEntries = newData[device]['gps'];
  //           const originalGpsEntries = newLastDataLog[device]['gps'];

  //           if (Object.keys(newLastDataLog).length > 1) {
  //             newLastDataLog[device]['gps'] = {
  //               // ...originalGpsEntries,
  //               ...newGpsEntries,
  //             };
  //           } else {
  //             newLastDataLog[device]['gps'] = {
  //               ...originalGpsEntries,
  //               ...newGpsEntries,
  //             };
  //           }
  //         }
  //       }
  //       setLastDataLog(newLastDataLog);
  //     } else {
  //       setLastDataLog(results.data.payload);
  //     }
  //   } catch (error) {
  //     console.error(getErrorMessage(error));
  //   } finally {
  //     setLoadingLastDataLog(false);
  //   }
  // };

  // useEffect(() => {
  //   if (asset && asset.companyId) {
  //     getLastDataLogDevice(
  //       {
  //         deviceType: 'gps',
  //         interval: 'minute',
  //         assetIds: asset.assetId,
  //         trailLength: trailLength,
  //       },
  //       showDotTrail
  //     );
  //   }
  // }, [asset, trailLength, showDotTrail]);

  const { gpsSummary: gpsSummmary } = useReportSummaryData({
    startAt: filter.startAt,
    endAt: filter.endAt,
    interval: filter.interval,
    timezone,
  });

  useEffect(() => {
    let lastDataLog: any = {};

    if (gpsLogs && Object.keys(gpsLogs).length > 0) {
      const lastKeyGps = Object.keys(gpsLogs)[Object.keys(gpsLogs).length - 1];

      if (
        gpsLogs[lastKeyGps] &&
        Object.keys(gpsLogs[lastKeyGps]).length > 0
      ) {
        lastDataLog = {
          [asset.name]: {
            assetId: asset.assetId,
            // gps: lastKeyGps ? { [lastKeyGps]: logs.gps![lastKeyGps] } : {},
            gps: gpsLogs,
            name: asset.name,
          },
        };
      }
    }

    if (logs.rpm) {
      const lastKeyRpm = Object.keys(logs.rpm)[
        Object.keys(logs.rpm).length - 1
      ];

      if (
        logs.rpm![lastKeyRpm] &&
        Object.keys(logs.rpm![lastKeyRpm]).length > 0
      ) {
        lastDataLog = {
          ...lastDataLog,
          [asset.name]: {
            ...lastDataLog[asset.name],
            rpm: lastKeyRpm ? { [lastKeyRpm]: logs.rpm![lastKeyRpm] } : {},
          },
        };
      }
    }
    // console.log('lastDataLog', lastDataLog);
    setLastDataLog(lastDataLog);
  }, [asset.assetId, asset.name, gpsLogs, logs.rpm]);

  const dataTableVesselTracking = useMemo(() => {
    if (gpsLogs && Object.keys(gpsLogs).length > 0 && gpsSummmary.avgSpeed) {
      const firstKey = Object.keys(gpsLogs)[0];
      const lastKey = Object.keys(gpsLogs)[Object.keys(gpsLogs).length - 1];

      if (gpsLogs[firstKey] && gpsLogs[lastKey]) {
        const firstGps = gpsLogs[firstKey];
        const lastGps = gpsLogs[lastKey];
        const firstLatitude =
          firstGps.stats?.firstLatitude ?? firstGps.latitude;
        const firstLongitude =
          firstGps.stats?.firstLongitude ?? firstGps.longitude;
        const lastLatitude = lastGps.stats?.lastLatitude ?? lastGps.latitude;
        const lastLongitude = lastGps.stats?.lastLongitude ?? lastGps.longitude;

        return defaultDataTable.map((item) =>
          item.key === '1'
            ? {
                ...item,
                position: `${latToDMS(firstLatitude)} ${longToDMS(
                  firstLongitude
                )}`,
                time: formatCurrentDate(
                  filter.startAt * 1000,
                  EFormatCurrentDate.DEFAULT_SHORT_MONTH
                ),
                speed: firstGps.speed.toFixed(2),
              }
            : item.key === '2'
            ? {
                ...item,
                position: `${latToDMS(lastLatitude)} ${longToDMS(
                  lastLongitude
                )}`,
                time: formatCurrentDate(
                  filter.endAt * 1000,
                  EFormatCurrentDate.DEFAULT_SHORT_MONTH
                ),
                speed: lastGps.speed.toFixed(2),
              }
            : item.key === '3'
            ? {
                ...item,
                position: gpsSummmary.avgSpeed,
              }
            : item.key === '4'
            ? {
                ...item,
                position: gpsSummmary.totalCruise,
              }
            : {
                ...item,
                position: '-',
              }
        );
      } else {
        return [];
      }
    }
  }, [filter.endAt, filter.startAt, gpsLogs, gpsSummmary]);

  return (
    <Wrapper>
      <SectionContainer style={{ marginTop: 15 }}>
        <SectionTitle>
          <CompassOutlined style={{ fontSize: 12, marginRight: 5 }} />
          GPS Summary
        </SectionTitle>
        <SectionAccordion onClick={() => handleToggleSection('section1')}>
          {showSections.section1 ? <MinusOutlined /> : <PlusOutlined />}
        </SectionAccordion>
      </SectionContainer>
      {showSections.section1 && (
        isMobile ? (
          <MobileGpsSummary>
            {(dataTableVesselTracking || defaultDataTable).map((item) => (
              <MobileGpsCard key={item.key}>
                <MobileGpsCardTitle>{item.header}</MobileGpsCardTitle>
                {item.key === '3' || item.key === '4' ? (
                  <MobileGpsMetric>
                    <MobileGpsValue>{item.position || '-'}</MobileGpsValue>
                    <Select
                      size='small'
                      value={item.key === '3' ? speedUnit : cruiseUnit}
                      style={{ width: 92 }}
                      onChange={(value) =>
                        item.key === '3'
                          ? setSpeedUnit(value)
                          : setCruiseUnit(value)
                      }
                      options={
                        item.key === '3' ? speedUnitOptions : cruiseUnitOptions
                      }
                    />
                  </MobileGpsMetric>
                ) : (
                  <MobileGpsDetails>
                    <MobileGpsDetail>
                      <span>Position</span>
                      <strong>{item.position || '-'}</strong>
                    </MobileGpsDetail>
                    <MobileGpsDetail>
                      <span>Time</span>
                      <strong>{item.time || '-'}</strong>
                    </MobileGpsDetail>
                    <MobileGpsDetail>
                      <span>Speed</span>
                      <MobileGpsMetric>
                        <strong>
                          {item.speed
                            ? speedUnit === 'KNOT'
                              ? toKnot(Number(item.speed)).toFixed(2)
                              : item.speed
                            : '-'}
                        </strong>
                        <Select
                          size='small'
                          value={speedUnit}
                          style={{ width: 92 }}
                          onChange={(value) => setSpeedUnit(value)}
                          options={speedUnitOptions}
                        />
                      </MobileGpsMetric>
                    </MobileGpsDetail>
                  </MobileGpsDetails>
                )}
              </MobileGpsCard>
            ))}
          </MobileGpsSummary>
        ) : (
          <Table
            dataSource={dataTableVesselTracking}
            columns={columnsVesselTracking}
            loading={loading || loadingTrackingGps}
            pagination={false}
            size='small'
          />
        )
      )}

      <SectionContainer style={{ marginTop: 15 }}>
        <SectionTitle>
          <EnvironmentOutlined style={{ fontSize: 12, marginRight: 5 }} />
          Map
        </SectionTitle>
        <SectionAccordion onClick={() => handleToggleSection('section2')}>
          {showSections.section2 ? <MinusOutlined /> : <PlusOutlined />}
        </SectionAccordion>
      </SectionContainer>
      {showSections.section2 && (
        <div
          style={{
            borderRadius: 10,
            overflow: 'hidden',
            marginBottom: 20,
            marginTop: 20,
          }}
        >
          <MapCustom
            height={
              isMobile ? '420px' : 'max(500px, calc(100vh - 280px))'
            }
            showAssetsIds={[asset.assetId]}
            loadingData={loadingLastDataLog || loadingTrackingGps}
            companyId={asset.companyId}
            mapConfig={{
              mapType,
              isShowMapCoordinate: true,
              isShowMapAttribution: true,
              isShowMapControl: true,
              isShowMapLayers: true,
              isShowMapSettings: true,
              isShowMapPolyline: true,
              showVesselLabel,
              showVesselOffline,
              showVesselOnline,
              showVesselWaiting,
              showVesselDotTrail: true,
              trailWidth,
              trailOpacity,
            }}
            lastDataLog={lastDataLog}
          />
        </div>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-top: 20px;

  @media (max-width: 767px) {
    margin: 12px 20px 0;
  }
`;

const SectionContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr) 40px;
  align-items: center;
  padding: 8px 12px;
  background-color: #fafafa;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f0f0f0;
  }

  @media (max-width: 767px) {
    min-height: 42px;
    padding: 10px 12px;
    background-color: #e8ebf3;
    border-radius: 8px 8px 0 0;

    &:hover {
      background-color: #e8ebf3;
    }
  }
`;

const SectionTitle = styled.div`
  grid-column: 1 / 4;
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  display: flex;
  align-items: center;
`;

const SectionAccordion = styled.div`
  grid-column: 4;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const MobileGpsSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
  padding: 10px;
  border: 1px solid #e8ecf3;
  border-top: 0;
  border-radius: 0 0 8px 8px;
  background: #ffffff;
`;

const MobileGpsCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid #e8ecf3;
  border-radius: 8px;
  background: #ffffff;
`;

const MobileGpsCardTitle = styled.div`
  color: #1e1e1e;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
`;

const MobileGpsDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const MobileGpsDetail = styled.div`
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr);
  gap: 8px;
  align-items: start;
  color: #1e1e1e;
  font-size: 12px;
  line-height: 1.3;

  span {
    color: #768499;
  }

  strong {
    min-width: 0;
    font-weight: 600;
    word-break: break-word;
  }
`;

const MobileGpsMetric = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
`;

const MobileGpsValue = styled.strong`
  min-width: 0;
  color: #1e1e1e;
  font-size: 14px;
  font-weight: 600;
`;

const CustomTable = styled(Table)`
  .ant-table-thead > tr > th {
    background-color: grey;
    color: black;
    text-align: center;
    border-radius: 0px !important;
    border: 1px solid #264284;
    padding: 1.5px !important;
  }

  .ant-table-thead > tr > th:first-child {
    background-color: #264284;
    color: white;
  }

  .ant-table-tbody > tr > td {
    border: 1px solid #264284;
    padding: 10px !important;
    text-align: center;
    padding: 1.5px !important;
  }

  .ant-table-tbody > tr > td:first-child {
    background-color: #264284;
    color: white;
    text-align: center;
  }

  td.ant-table-cell:hover {
    color: #264284 !important;
  }

  .ant-table-cell::before {
    content: none !important;
  }
`;

export default VesselTracking;
